<div class="manage-values-dialog-shell vg-dialog-shell">
  <div class="vg-dialog-header">
    <div class="dialog-header__text">
      <h2 mat-dialog-title class="dialog-title">{{ title }}</h2>
      <p class="dialog-subtitle">{{ subtitle }}</p>
    </div>
    <button type="button" mat-icon-button (click)="onCancel()" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="mat-typography manage-values-dialog vg-dialog-body">
    <div class="add-value-row" fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="start center">
      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="add-value-field" fxFlex>
        <input matInput [(ngModel)]="newValueInput" [placeholder]="addValuePlaceholder" (keydown)="onValueInputKeydown($event)"/>
      </mat-form-field>
      <button type="button" class="sat-btn sat-btn--primary sat-btn--compact" (click)="addValue()">
        Add Value
      </button>
    </div>

    <p class="values-meta">
      {{ values.length }} value{{ values.length === 1 ? '' : 's' }} defined | Drag to reorder | Click &times; to remove
    </p>

    <div class="values-list-container" cdkDropList (cdkDropListDropped)="drop($event)">
      <div class="value-row" *ngFor="let value of values; let i = index" cdkDrag [class.value-row--alt]="i % 2 === 1" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="value-row__start" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
          <mat-icon cdkDragHandle class="drag-handle">drag_indicator</mat-icon>
          <span class="value-label">{{ value.label }}</span>
        </div>
        <div class="value-row__end" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
          <span class="store-count" *ngIf="value.storeCount > 0">Used by {{ value.storeCount }} stores</span>
          <button type="button" class="remove-value-btn" (click)="removeValue(i)" aria-label="Remove value">&times;</button>
        </div>
      </div>
    </div>

    <div class="vg-warning-box">
      <strong>Warning:</strong> Removing a value that is currently assigned to stores will clear that value from those store records. This may affect version filtering results.
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="sat-dialog-footer">
    <button type="button" class="sat-btn sat-btn--outline" (click)="onCancel()">
      Cancel
    </button>
    <button type="button" class="sat-btn sat-btn--primary" (click)="onSave()">
      Save Changes
    </button>
  </mat-dialog-actions>
</div>
